

















































import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';

import {ISettingsService} from '@/services/settings/ISettings.service';
import {Setting, Theme} from '@/services/settings/Settings.types';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class About extends Mixins<BaseComponent>(BaseComponent) {

  @Inject(Symbol.for('ISettingsService'))
  private settingsService!: ISettingsService;

  private isOpen: boolean = false;

  private version = process.env.VERSION;

  private Setting = Setting;
  private Theme = Theme;

  public open() {
    this.isOpen = true;
  }
}
